import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const rateSlice = createSlice({
  name: "rate",
  initialState,
  reducers: {
    setData: (state, action) => ({
      ...action.payload,
    }),
    removeData: (state, action) => ({}),
  },
});

export const { removeData, setData } = rateSlice.actions;

export default rateSlice.reducer;
